<template>
  <router-link
    class="navbar-item"
    :class="{ 'is-active': isActiveRoute('agency-companies') }"
    :to="{ name: 'agency-companies', params: { agencyId } }"
  >
    <span class="icon" :class="{ 'has-text-primary': isActiveRoute('agency-companies') }">
      <font-awesome-icon
        :icon="['fal', 'buildings']"
        :active-icon="['fadl', 'buildings']"
        :active="isActiveRoute('agency-companies')"
      />
    </span>
    <span :class="{ 'has-text-primary': isActiveRoute('agency-companies') }">Companies</span>
  </router-link>

  <router-link
    class="navbar-item position-relative"
    :class="{ 'is-active': isActiveRoute('agency-requests') }"
    :to="{ name: 'agency-requests', params: { agencyId } }"
    :title="pendingCount ? `${pendingCount} request(s) awaiting your review` : ''"
  >
    <span
      class="icon icon-with-dot"
      :class="{ 'has-text-primary': isActiveRoute('agency-requests') }"
    >
      <font-awesome-icon
        :icon="['fal', 'inbox']"
        :active-icon="['fadl', 'inbox']"
        :active="isActiveRoute('agency-requests')"
      />
      <span v-if="pendingCount" class="notification-dot"></span>
    </span>
    <span :class="{ 'has-text-primary': isActiveRoute('agency-requests') }">Requests</span>
  </router-link>

  <!-- Team and Settings run the agency: its roster of people, who reaches which
       company, and the markup. A scoped member has no business in either, so
       they are hidden rather than shown read-only. The router guard enforces
       it — this only keeps the door out of sight. -->
  <router-link
    v-if="isAgencyAdmin"
    class="navbar-item"
    :class="{ 'is-active': isActiveRoute('agency-users') }"
    :to="{ name: 'agency-users', params: { agencyId } }"
  >
    <span class="icon" :class="{ 'has-text-primary': isActiveRoute('agency-users') }">
      <font-awesome-icon
        :icon="['fal', 'users']"
        :active-icon="['fadl', 'users']"
        :active="isActiveRoute('agency-users')"
      />
    </span>
    <span :class="{ 'has-text-primary': isActiveRoute('agency-users') }">Team</span>
  </router-link>

  <router-link
    v-if="isAgencyAdmin"
    class="navbar-item"
    :class="{ 'is-active': isActiveRoute('agency-settings') }"
    :to="{ name: 'agency-settings', params: { agencyId } }"
  >
    <span class="icon" :class="{ 'has-text-primary': isActiveRoute('agency-settings') }">
      <font-awesome-icon
        :icon="['fal', 'gear']"
        :active-icon="['fadl', 'gear']"
        :active="isActiveRoute('agency-settings')"
      />
    </span>
    <span :class="{ 'has-text-primary': isActiveRoute('agency-settings') }">Settings</span>
  </router-link>

</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useNavbarState } from '@/composables/useNavbarState';
import { useAgencyStore } from '@/stores/agencyStore';
import { useUserAuthStore } from '@/stores/userAuthStore';

const route = useRoute();
const agencyStore = useAgencyStore();
const userAuthStore = useUserAuthStore();

const { isActiveRoute } = useNavbarState();
const isAgencyAdmin = computed(() => userAuthStore.isAgencyAdmin);
const agencyId = computed(() => route.params.agencyId);
const pendingCount = computed(() => agencyStore.pendingCount);
</script>

<style lang="scss" scoped>
@import '@/assets/scss/navbar-shared';
</style>
